import {APIService} from '@/services/api.service';
import {RecommendationContext} from '../state/global.types';

export async function loadSourcePOI(sourceId: string): Promise<RecommendationContext> {
  const {poi} = await APIService.get<{poi: RecommendationContext}>(`domain/poi`, {
    params: {
      id: sourceId,
      mode: process.env.VUE_APP_MODE,
    },
  });
  return poi;
}
